module.exports = __webpack_public_path__ + "static/media/Face_recognition_SDK@2x.bfbf25ad.png";